import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-row text-gray-400" };
const _hoisted_2 = { class: "flex flex-row my-2 text-gray-400" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { style: { "color": "red" } }, "*", -1 /* HOISTED */);
const _hoisted_4 = {
    key: 3,
    class: "flex flex-row my-2 text-gray-400"
};
const _hoisted_5 = { class: "ml-3" };
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, ChatWidgetSettingsDataOptions } from '@/helper/const';
import { isValidUrl, updateChatWidgetSetting } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { UICheckbox, UIDivider, UIFormItem, UIInput, UIInputGroup, UIInputGroupLabel, UISwitch, UITextXsRegular, } from '@gohighlevel/ghl-ui';
import { inject, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdditionalOptions',
    setup(__props) {
        const companyInfo = inject('companyInfo');
        const validUrl = ref(false);
        const urlRule = ref({
            message: 'Please input valid website',
            trigger: ['input'],
            validator: () => {
                if (!appState.chatWidgetSettingsData.agencyWebsite)
                    return false;
                return isValidUrl(appState.chatWidgetSettingsData.agencyWebsite);
            },
        });
        const urlValidator = (val) => {
            appState.chatWidgetSettingsData.agencyWebsite = val;
            validUrl.value = isValidUrl(val);
            if (validUrl.value) {
                updateChatWidgetSetting(ChatWidgetSettingsDataOptions.AGENCY_WEBSITE, val);
            }
            else {
                appState.unsavedChanges = false;
            }
        };
        const handleAgencyBranding = (val) => {
            const { agencyWebsite, agencyName } = appState.chatWidgetSettingsData;
            const { website, name } = companyInfo || {};
            updateChatWidgetSetting(ChatWidgetSettingsDataOptions.SHOW_AGENCY_BRANDING, val);
            updateChatWidgetSetting(ChatWidgetSettingsDataOptions.AGENCY_WEBSITE, agencyWebsite || website);
            updateChatWidgetSetting(ChatWidgetSettingsDataOptions.AGENCY_NAME, agencyName || name);
        };
        const handleShowConsentCheckbox = (val) => {
            appState.chatWidgetSettingsData.advanceSettings.defaultConsentCheck = val;
            appState.unsavedChanges = true;
        };
        const updateShowConsentCheckbox = (val) => {
            appState.chatWidgetSettingsData.showConsentCheckbox = val;
            if (!val) {
                appState.chatWidgetSettingsData.advanceSettings.defaultConsentCheck = true;
            }
            appState.unsavedChanges = true;
        };
        const updateBrandingTitle = (val) => {
            appState.chatWidgetSettingsData.advanceSettings.brandingTitle = val;
            appState.unsavedChanges = true;
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISwitch), {
                        rubberBand: false,
                        value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.showAgencyBranding,
                        "onUpdate:value": handleAgencyBranding
                    }, null, 8 /* PROPS */, ["value"]),
                    _createElementVNode("div", null, [
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.agencyBranding'),
                            "show-feedback": false,
                            class: "ml-2 mt-0.5"
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(UITextXsRegular), { class: "ml-2" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sidebar.agencyBrandingHelper')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.showAgencyBranding) === true)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 0,
                        class: "my-2",
                        label: _ctx.$t('sidebar.brandingTitle'),
                        "show-feedback": false
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createVNode(_unref(UIInput), {
                                    type: "text",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.brandingTitle,
                                    placeholder: _unref(i18n).global.t('placeholder.brandingTitle'),
                                    "onUpdate:modelValue": updateBrandingTitle
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.showAgencyBranding) === true)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 1,
                        class: "my-2",
                        label: _ctx.$t('sidebar.displayName'),
                        "show-feedback": false
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    type: "text",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.agencyName,
                                    placeholder: _unref(i18n).global.t('placeholder.agencyName'),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).AGENCY_NAME, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.showAgencyBranding) === true)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 2,
                        class: "my-2",
                        label: _ctx.$t('sidebar.url'),
                        rule: urlRule.value,
                        required: true
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIInputGroup), { style: { "max-width": "400px" } }, {
                                default: _withCtx(() => {
                                    var _a;
                                    return [
                                        _createVNode(_unref(UIInputGroupLabel), null, {
                                            default: _withCtx(() => [
                                                _createTextVNode("https://")
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_unref(UIInput), {
                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                            modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.agencyWebsite,
                                            placeholder: _unref(i18n).global.t('placeholder.agencyWebsite'),
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = val => urlValidator(val))
                                        }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                                    ];
                                }),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "rule"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(UIDivider)),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UISwitch), {
                        rubberBand: false,
                        value: (_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.showConsentCheckbox,
                        "onUpdate:value": updateShowConsentCheckbox
                    }, null, 8 /* PROPS */, ["value"]),
                    _createElementVNode("div", null, [
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.consentCheckboxForHipaa'),
                            "show-feedback": false,
                            class: "ml-2 mt-0.5"
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(UITextXsRegular), { class: "ml-2" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sidebar.hipaaHelper')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        ((_f = _unref(appState).chatWidgetSettingsData) === null || _f === void 0 ? void 0 : _f.showConsentCheckbox)
                            ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                key: 0,
                                class: "ml-2 mt-2"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_3,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.hipaaHelper2')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                ((_g = _unref(appState).chatWidgetSettingsData) === null || _g === void 0 ? void 0 : _g.showConsentCheckbox)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(UICheckbox), {
                            class: "ml-2",
                            checked: (_j = (_h = _unref(appState).chatWidgetSettingsData) === null || _h === void 0 ? void 0 : _h.advanceSettings) === null || _j === void 0 ? void 0 : _j.defaultConsentCheck,
                            "onUpdate:checked": handleShowConsentCheckbox,
                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_CHECKBOX
                        }, null, 8 /* PROPS */, ["checked", "id"]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(UIFormItem), {
                                label: _ctx.$t('sidebar.defaultConsentCheck'),
                                "show-feedback": false
                            }, null, 8 /* PROPS */, ["label"])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(UIFormItem), {
                    class: "my-2",
                    label: _ctx.$t('sidebar.legalMsg'),
                    "show-feedback": false
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIInput), {
                                type: "textarea",
                                ":rows": 4,
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.legalMsg,
                                placeholder: _unref(i18n).global.t('placeholder.legalMsg'),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LEGAL_MSG, val))
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
